<template>
  <div>
    <div class="fixedIcon fixedIconMobile" v-if="isMobile">
      <div class="item" @click="isShowOffFn">
        <img class="icon default" src="../assets/image/wxOfficial1.png" />
        <img class="icon cover" src="../assets/image/wxOfficial2.png" />
        <span>微信公众号</span>
        <div class="hoverCon" v-if="isShowOff">
          <img src="../assets/image/wxOfficeCode.jpg" alt="" style="padding: 0 14px;">
          <span>微信扫码关注官方公众号</span>
        </div>
      </div>
      <div class="item" @click="isShowWXFn">
        <img class="icon default" src="../assets/image/wxIcon1.png" />
        <img class="icon cover" src="../assets/image/wxIcon2.png" />
        <span>企业微信</span>
        <div class="hoverCon" v-if="isShowWX">
          <img src="../assets/image/wxCode.png" alt="" style="padding: 0 8px;">
          <span>微信扫码添加企业微信</span>
        </div>
      </div>
      <div class="item" @click="isShowEmailFn">
        <img class="icon default" src="../assets/image/emailIcon1.png" />
        <img class="icon cover" src="../assets/image/emailIcon2.png" />
        <span>信箱</span>
        <div class="hoverCon" v-if="isShowEmail">
          <span>marketing@youjiajk.com</span>
        </div>
      </div>
    </div>
    <div class="fixedIcon" v-else>
      <div class="item" @mouseover="addActive($event)" @mouseout="removeActive($event)">
        <img class="icon default" src="../assets/image/wxOfficial1.png" />
        <img class="icon cover" src="../assets/image/wxOfficial2.png" />
        <span>微信公众号</span>
        <div class="hoverCon hoverConDisplay">
          <img src="../assets/image/wxOfficeCode.jpg" alt="" style="padding: 0 15px;">
          <span>微信扫码关注官方公众号</span>
        </div>
      </div>
      <div class="item" @mouseover="addActive($event)" @mouseout="removeActive($event)">
        <img class="icon default" src="../assets/image/wxIcon1.png" />
        <img class="icon cover" src="../assets/image/wxIcon2.png" />
        <span>企业微信</span>
        <div class="hoverCon hoverConDisplay">
          <img src="../assets/image/wxCode.png" alt="" style="padding: 0 8px;">
          <span>微信扫码添加企业微信</span>
        </div>
      </div>
      <div class="item" @mouseover="addActive($event)" @mouseout="removeActive($event)">
        <img class="icon default" src="../assets/image/emailIcon1.png" />
        <img class="icon cover" src="../assets/image/emailIcon2.png" />
        <span>信箱</span>
        <div class="hoverCon hoverConDisplay">
          <span>marketing@youjiajk.com</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['isMobile'],
  data () {
    return {
      isShowWX: false,
      isShowEmail: false,
      isShowOff: false
    }
  },
  methods: {
    addActive ($event) {
      $event.currentTarget.className = 'item coverItem'
    },
    removeActive ($event) {
      $event.currentTarget.className = 'item'
    },
    isShowWXFn () {
      this.isShowEmail = false
      this.isShowWX = !this.isShowWX
    },
    isShowEmailFn () {
      this.isShowWX = false
      this.isShowEmail = !this.isShowEmail

    },
    isShowOffFn () {
      this.isShowOff = !this.isShowOff
      this.isShowWX = false
      this.isShowEmail = false

    }
  }
}
</script>

<style lang="less" scoped>
.fixedIcon {
  position: fixed;
  right: 20px;
  bottom: 10%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // width: 66px;
  border-radius: 6px;
  box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.09);
  z-index: 99;

  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 9px 7px;
    font-size: 12px;
    color: #000000;
    font-family: Source Han Sans CN, Source Han Sans CN-5;
    position: relative;

    .icon {
      width: 23px;
      height: 23px;
    }

    &:first-child {
      border-bottom: 1px solid #F1F2F4;

      .icon {
        width: 26px;
        height: 26px;
      }
    }

    span {
      margin-top: 6px;
    }

    .default {
      display: inline-block;
    }

    .cover {
      display: none;
    }

    .hoverCon {
      position: absolute;
      background: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN-5;
      font-weight: 400;
      text-align: left;
      color: #000000;
      line-height: 18px;
      right: 72px;
      top: 0;
      padding: 14px 15px 14px;
      text-align: center;
      border-radius: 6px;
      box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.09);

      img {
        width: 104px;
        height: 103px;
        margin-bottom: 7px;
        margin-top: 4px;
      }

      span {
        margin-top: 0;
      }
    }

    .hoverConDisplay {
      display: none;
    }
  }

  .coverItem {
    color: #FC8046;

    .default {
      display: none;
    }

    .cover {
      display: inline-block;
    }

    .hoverConDisplay {
      display: inline-block;
    }
  }
}

.fixedIconMobile {
  right: 0.1rem;
  // width: 1.32rem;
  border-radius: 0.12rem;
  box-shadow: 0 0.04rem 0.13rem 0 rgba(0, 0, 0, 0.09);
  bottom: 24%;

  .item {
    padding: 0.18rem 0.13rem;
    font-size: 0.24rem;

    .icon {
      width: 0.38rem;
      height: 0.38rem;
    }

    &:first-child {
      border-bottom: 0.02rem solid #F1F2F4;

      .icon {
        width: 0.48rem;
        height: 0.48rem;
      }

      .hoverCon {
        right: 1.38rem;
        top: 0;
      }
    }

    span {
      margin-top: 0.17rem;
    }

    .hoverCon {
      padding: 0.18rem 0.15rem;
      right: 1.2rem;
      top: 0.3rem;

      span {
        margin-top: 0;
      }
    }
  }

  .hoverConDisplay {
    display: inline-block;

  }
}
</style>


// WEBPACK FOOTER //
// src/components/iconComponents.vue